import '../backendmodel';
import { ElapsedTimeMetric } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ElapsedTimeMetric),
    adapts: {
        timeout: '*'
    }
})
export class ElapsedTimeMetricAdapter {
    public toResource(elapsedTimeMetric: ElapsedTimeMetric): Model.PipelinePolicy {
        const modelElapsedTimeMetric: Model.ElapsedTimeMetric = {
            duration: elapsedTimeMetric.duration
        };
        return modelElapsedTimeMetric;
    }

    public toModel(modelElapsedTimeMetric: Model.ElapsedTimeMetric): ElapsedTimeMetric {
        const elapsedTimeMetric: ElapsedTimeMetric = new ElapsedTimeMetric();
        elapsedTimeMetric.duration = modelElapsedTimeMetric === undefined ? undefined : modelElapsedTimeMetric.duration;
        return elapsedTimeMetric;
    }
}
